import { sylvanus } from '~/services/serviceInstances';

import { PromptModelConfig } from '../../types/sylvanus/model';

interface Request {
  config: PromptModelConfig;
  name: string;
}

type Response = void;

export const checkLibraryModelConfig = async ({
  config,
  name,
}: Request): Promise<Response> => {
  const response: Response = await sylvanus.post(`model/config-check`, {
    ...config,
    field_name: name,
  });
  return response;
};
